/**
 * @generated SignedSource<<f1309ae4718e1196170a139d1c70fb21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type NavigationType = "MENU" | "SHORTCUTS" | "%future added value";
export type ImportedNavigationItemsQuery$variables = {
  brandId: string;
  navigationType?: NavigationType | null;
};
export type ImportedNavigationItemsQuery$data = {
  readonly importedNavigationItems: {
    readonly menuItems: ReadonlyArray<{
      readonly children: ReadonlyArray<{
        readonly children: ReadonlyArray<{
          readonly index: number;
          readonly label: string;
          readonly localizations: ReadonlyArray<{
            readonly languageCode: KinnLanguageCode;
            readonly text: string;
            readonly url: string | null;
          }>;
          readonly url: string;
        }>;
        readonly index: number;
        readonly label: string;
        readonly localizations: ReadonlyArray<{
          readonly languageCode: KinnLanguageCode;
          readonly text: string;
          readonly url: string | null;
        }>;
        readonly url: string;
      }>;
      readonly index: number;
      readonly label: string;
      readonly localizations: ReadonlyArray<{
        readonly languageCode: KinnLanguageCode;
        readonly text: string;
        readonly url: string | null;
      }>;
      readonly url: string;
    }> | null;
    readonly shortcutsItems: ReadonlyArray<{
      readonly children: ReadonlyArray<{
        readonly children: ReadonlyArray<{
          readonly index: number;
          readonly label: string;
          readonly localizations: ReadonlyArray<{
            readonly languageCode: KinnLanguageCode;
            readonly text: string;
            readonly url: string | null;
          }>;
          readonly url: string;
        }>;
        readonly index: number;
        readonly label: string;
        readonly localizations: ReadonlyArray<{
          readonly languageCode: KinnLanguageCode;
          readonly text: string;
          readonly url: string | null;
        }>;
        readonly url: string;
      }>;
      readonly index: number;
      readonly label: string;
      readonly localizations: ReadonlyArray<{
        readonly languageCode: KinnLanguageCode;
        readonly text: string;
        readonly url: string | null;
      }>;
      readonly url: string;
    }> | null;
  };
};
export type ImportedNavigationItemsQuery = {
  response: ImportedNavigationItemsQuery$data;
  variables: ImportedNavigationItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "navigationType"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedUrlType",
  "kind": "LinkedField",
  "name": "localizations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ImportedNavigationItemType",
    "kind": "LinkedField",
    "name": "children",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ImportedNavigationItemType",
        "kind": "LinkedField",
        "name": "children",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "navigationType",
        "variableName": "navigationType"
      }
    ],
    "concreteType": "ImportedMenuItemsType",
    "kind": "LinkedField",
    "name": "importedNavigationItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ImportedNavigationItemType",
        "kind": "LinkedField",
        "name": "menuItems",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ImportedNavigationItemType",
        "kind": "LinkedField",
        "name": "shortcutsItems",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportedNavigationItemsQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportedNavigationItemsQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "b1d06a8bca86ccbb595e406bc121b435",
    "id": null,
    "metadata": {},
    "name": "ImportedNavigationItemsQuery",
    "operationKind": "query",
    "text": "query ImportedNavigationItemsQuery(\n  $brandId: ID!\n  $navigationType: NavigationType\n) {\n  importedNavigationItems(brandId: $brandId, navigationType: $navigationType) {\n    menuItems {\n      index\n      label\n      url\n      localizations {\n        languageCode\n        text\n        url\n      }\n      children {\n        index\n        label\n        url\n        localizations {\n          languageCode\n          text\n          url\n        }\n        children {\n          index\n          label\n          url\n          localizations {\n            languageCode\n            text\n            url\n          }\n        }\n      }\n    }\n    shortcutsItems {\n      index\n      label\n      url\n      localizations {\n        languageCode\n        text\n        url\n      }\n      children {\n        index\n        label\n        url\n        localizations {\n          languageCode\n          text\n          url\n        }\n        children {\n          index\n          label\n          url\n          localizations {\n            languageCode\n            text\n            url\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4f0108c069ef78f1715f80f2f15adbe";

export default node;
